import {createMuiTheme} from '@material-ui/core/styles'
export const colors = {
  purple: '#59637f',
  purple2: '#1f2d4b',
  purple3: '#33377f',
  purple4: '#17233E',
  purple5: '#0f1729',
  purple6: '#10182a',
  purple7: '#444e63',
  selectedPurple: '#141f33',
  lightPurple: '#6879a4',
  darkPurple: '#0E131F',
  darkPurple2: '#070C1B',
  darkPurple3: '#070b15',
  white: '#ffffff',
  offWhite: '#EBF3F7',
  blue: '#3b72b7',
  blue2: '#407dc9',
  blue3: '#2c5083',
  blue4: '#417dca',
  lightBlue: '#4597c2',
  brightBlue: '#417cca',
  blueGreen: '#4ed1b1',
  blueGreen2: '#47a8bc',
  green: '#4dcfb1',
  brightGreen: '#2dad9d',
  darkGreen: '#13332c',
  gray: '#838a98',
  deepBlue: '#151c2d',
  turqoise: '#44a5c0',
  lightGrey: '#c5c7cc',
  purpleGrey: '#98a0bb',
  black: '#000000',
}

const theme = createMuiTheme({
  palette: {
    secondary: {main: colors.blue},
    primary: {main: colors.purple},
    type: 'light',
  },
  typography: {
    fontFamily: 'Montserrat',
    useNextVariants: true,
    //  "fontSize": 14,
    //  "fontWeightLight": 300,
    //  "fontWeightRegular": 400,
    //  "fontWeightMedium": 500
    // }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 750,
      md: 1000,
      lg: 1250,
    },
  },
})

export default theme

export const mobileTheme = createMuiTheme({
  palette: {
    secondary: {main: colors.blue},
    primary: {main: colors.purple},
    type: 'dark',
    text: {primary: '#ddd'},
  },
  typography: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    useNextVariants: true,
    //  "fontSize": 14,
    //  "fontWeightLight": 300,
    //  "fontWeightRegular": 400,
    //  "fontWeightMedium": 500
    // }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 2000,
    },
  },
})

const drawerWidth = 240
export const styles = (theme) => ({
  root: {
    display: 'flex',
    // flexGrow: 1,
    backgroundColor: 'transparent',
  },
  paper: {
    position: 'absolute',
    // maxWidth: theme.spacing(80),
    width: `100%`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  },
  wrapper: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  homeWrapper: {
    overflowX: 'hidden',
    paddingTop: '20px',
  },
  noPadding: {
    paddingTop: '0px',
    paddingLeft: '0px',
    paddingRight: '0px',
    paddingBottom: '0px',
  },

  plotWrapper: {
    // paddingLeft: theme.spacing(10)
    width: '75%',
    margin: 'auto',
  },
  button: {
    margin: theme.spacing(1),
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  input: {
    backgroundColor: 'white',
  },
  gridItem: {
    // backgroundColor: theme.palette.common.grey,
    backgroundColor: '#e0e0e0',
    margin: theme.spacing(1),
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  appBarWithDrawer: {
    backgroundColor: theme.palette.background.paper,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  media: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  card: {
    width: 345,
    // minWidth: 345,
  },
  cardSelected: {
    backgroundColor: 'green',
  },
  gridExplainerItem: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  tagline: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
})



// WEBPACK FOOTER //
// ./src/Theme.js